<template>
  <div class="footer-container">
    <div class="stars"></div>
    <div class="footer-content">
      <div class="col">
        <h4>SHARE</h4>
        <ul>
          <li>
            <a @click="$ga.event('footer', 'share-mail');" href="mailto:?&subject=Check out Flat UI Colors 2 🎨&body=Hey,%0A%0AI've%20recently%20stumbled%20upon%20Flat%20UI%20Colors%202.%20It%20has%20280%20handpicked%20colors%20ready%20for%20COPY%20/%20PASTE%20for%20your%20needs.%20Thought%20it%20might%20help.%0A%0ACheck%20it%20out%20here%3A%0Ahttp%3A//flatuicolors.com%0A%0ACheers," target="_blank">Send via e-mail</a>
          </li>
          <li>
            <a @click="$ga.event('footer', 'share-twitter');" href="https://twitter.com/home?status=Flat%20UI%20Colors%202%20%F0%9F%8E%A8%20280%20handpicked%20colors%20ready%20for%20COPY%20/%20PASTE%20for%20your%20needs.%20http%3A//flatuicolors.com%20via%20%40ahmetsulek%20related%20%40ahmetsulek" target="_blank">Share on Twitter</a>
          </li>
          <li>
            <a @click="$ga.event('footer', 'share-facebook');" href="https://www.facebook.com/sharer/sharer.php?u=http%3A//flatuicolors.com" target="_blank">Share on Facebook</a>
          </li>
          <li>
            <a @click="$ga.event('footer', 'share-gplus');" href="https://plus.google.com/share?url=http://flatuicolors.com" target="_blank">Share on Google Plus</a>
          </li>
          <li>
            <a @click="$ga.event('footer', 'share-linkedin');" href="https://www.linkedin.com/shareArticle?mini=true&url=http%3A//flatuicolors.com&title=%F0%9F%8E%A8%20280%20handpicked%20colors%20ready%20for%20COPY%20/%20PASTE%20for%20your%20needs.&summary=&source=http%3A//flatuicolors.com" target="_blank">Share on LinkedIn</a>
          </li>
        </ul>
      </div>
      <div class="col">
        <h4>MORE</h4>
        <ul>
          <li>
            <a href="javascript:;" class="say-hi" @click="openCrisp();" target="_blank">
              <span>👋</span>&nbsp;&nbsp;&nbsp;Contact Me</a>
          </li>
          <li>

          </li>
          <li>
            <router-link class="" to="/subscribe" @click.native="$ga.event('footer', 'subscribe');">
              <span>📩</span>&nbsp;&nbsp;&nbsp;Subscribe</router-link>
          </li>
          <li>
            <router-link class="" to="/submit" @click.native="$ga.event('footer', 'submit');">
              <span>🎉</span>&nbsp;&nbsp;&nbsp;Submit</router-link>
          </li>
          <li>
            <router-link class="replay-onboarding" to="/onboarding" @click.native="$ga.event('footer', 'replay');">
              <span>🤙</span>&nbsp;&nbsp;Replay Onboarding</router-link>
          </li>
        </ul>
      </div>
      <div class="col col-about">
        <h4>ABOUT</h4>
        <p>
          Flat UI Colors 2 brought to you by Ahmet Sulek.
          <br>
          <a href="http://twitter.com/ahmetsulek" @click="$ga.event('footer', 'about-twitter');" target="_blank">Follow me on Twitter</a> or
          <router-link to="/subscribe" @click.native="$ga.event('footer', 'about-subscribe');">Subscribe</router-link> to be the first to know
          <br> when I launch new products.
          <br><br> Read the
          <a href="https://medium.com/collect-ui-design-ui-ux-inspiration-blog/flat-ui-colors-2-13-countries-13-designers-13-color-palettes-more-1d0ecdd66301" @click="$ga.event('footer', 'about-medium');" target="_blank">article on Medium</a> to learn more.
        </p>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: "Footer",
  components: {},
  data() {
    return {};
  },
  methods: {
    openCrisp() {
      this.$ga.event("footer", "say-hi");
      $crisp.push(["do", "chat:show"]);
      $crisp.push(["do", "chat:open"]);
    }
  }
};
</script>
<style lang="scss" scoped>
.footer-container {
  display: block;
  width: 100%;
  float: left;
  background: #0c2461;
  height: 285px;
  margin-top: 80px;
  color: #fff;
  position: relative;
  .stars {
    background-image: url("~@/assets/stars-opacity.svg");
    width: 100%;
    height: 100%;
    position: absolute;
    pointer-events: none;
    left: 0;
    top: 0;
  }
  .footer-content {
    width: 1024px;
    margin: 0 auto;
    padding-top: 40px;
    .col {
      float: left;
      width: 240px;
      h4 {
        margin-bottom: 20px;
        letter-spacing: 1px;
        font-weight: 700;
      }
      a {
        color: #fff;
      }
      ul {
        float: left;
        width: 100%;
        li {
          float: left;
          width: 100%;
          height: 28px;
          line-height: 28px;
          a {
            width: 100%;
            &:after {
              content: "→";
              opacity: 0;
              position: relative;
              top: 1px;
              margin-left: 0px;
              transition: all 0.2s;
            }
            &.replay-onboarding {
              span {
                display: inline-block;
                width: 19px;
                animation: tada 1s both 0;
              }
              &:hover span {
                animation-iteration-count: infinite;
              }
            }
            &.say-hi {
              span {
                display: inline-block;
                width: 19px;
                animation: action-swing 1s both 0;
              }
                &:hover span {
                  animation-iteration-count: infinite;
                }
            }
            &:hover:after {
              opacity: 1;
              margin-left: 4px;
            }
          }
        }
      }
    }
    .col-about {
      width: 400px;
      p {
        line-height: 28px;
        a {
          text-decoration: underline;
        }
      }
    }
  }
}

@media (max-width: 600px) {
  .footer-container {
    margin-left: -30px;
    padding: 0px 30px;
    padding-right: 30px;
    height: auto;
    .footer-content {
      width: 100%;
      .col {
        margin-bottom: 30px;
      }
      .col-about {
        width: 100%;
      }
    }
  }
}

@keyframes tada {
  0% {
    transform: scale3d(1, 1, 1);
  }

  10%,
  20% {
    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
  }

  30%,
  50%,
  70%,
  90% {
    transform: scale3d(1.2, 1.2, 1.2) rotate3d(0, 0, 1, 3deg);
  }

  40%,
  60%,
  80% {
    transform: scale3d(1.2, 1.2, 1.2) rotate3d(0, 0, 1, -3deg);
  }

  100% {
    transform: scale3d(1, 1, 1);
  }
}

@keyframes action-swing {
  0% {
    transform: rotateZ(0deg);
  }
  20% {
    transform: rotateZ(15deg);
  }
  40% {
    transform: rotateZ(-15deg);
  }
  60% {
    transform: rotateZ(7deg);
  }
  80% {
    transform: rotateZ(-7deg);
  }
  100% {
    transform: rotateZ(0deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue